import { css } from '@emotion/core';
import { Css, Responsive } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';

export const solicitationListHeaderStyles = css`
	font-weight: 300;
	font-size: ${Css.pxToRem(14)};
	line-height: ${Css.pxToRem(19)};
	padding-bottom: ${Css.pxToRem(8)};
	color: ${Color.Neutral6};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-weight: 500;
		font-size: ${Css.pxToRem(16)};
		color: ${Color.OnBackground};
	}
`;

export const proposerListValueStylesMobile = css`
	font-weight: 300;
	font-size: ${Css.pxToRem(14)};
	text-align: end;
`;
